import Option from '@danwang/option';
import {motion} from 'framer-motion';
import * as React from 'react';
import {cn} from 'src/lib/utils';

type Props = React.ComponentProps<typeof motion.div> & {
  onOverlayClick?: () => void;
  dimBackground?: boolean;
  blurBackground?: boolean;
  // When false the overlay ignores pointer events, letting clicks reach the
  // elements underneath; the owner must detect outside clicks itself.
  interactive?: boolean;
};

const Overlay = (props: Props) => {
  const {onOverlayClick, dimBackground, blurBackground, interactive, ...rest} =
    props;
  const isInteractive = Option(interactive).getOrElse(true);
  const ref = React.useRef<HTMLDivElement>(null);
  const handleClick = (e: React.MouseEvent) => {
    if (ref.current === e.target) {
      onOverlayClick?.();
    }
  };
  const shouldDim = Option(dimBackground).getOrElse(false);
  const dimProps = shouldDim
    ? {
        initial: {backgroundColor: 'rgba(0, 0, 0, 0)'},
        animate: {backgroundColor: 'rgba(0, 0, 0, 0.2)'},
        exit: {backgroundColor: 'rgba(0, 0, 0, 0)'},
        transition: {duration: 0.3},
      }
    : {};
  return (
    <motion.div
      {...rest}
      {...dimProps}
      ref={ref}
      onClick={handleClick}
      className={cn(
        'fixed inset-0 z-[1]',
        isInteractive ? 'pointer-events-auto' : 'pointer-events-none',
        blurBackground && 'backdrop-blur-[1px]',
      )}
    >
      {props.children}
    </motion.div>
  );
};
export {Overlay};
